import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() { }
  log(_message?: any, ..._optionalParams: any[]): void {
  }

  error(_message?: any, ..._optionalParams: any[]): void {
  }

  warn(_message?: any, ..._optionalParams: any[]): void {
  }
}
